import useLocalizedCurrencyFormatter from '@/hooks/useLocalizedCurrencyFormatter';
import { type FC } from 'react';

type PriceDisplayProps = {
  amount?: number;
};

const PriceDisplay: FC<PriceDisplayProps> = ({ amount = 0 }) => {
  const numberFormatter = useLocalizedCurrencyFormatter();

  const formattedPrice = numberFormatter.format(Number(amount.toFixed(2)));
  const priceWithSpacing = formattedPrice.replace(/^([^\d\s]+)(\d)/, '$1 $2');

  return <span>{priceWithSpacing}</span>;
};

export default PriceDisplay;
